import styled, { css } from 'styled-components';
import { B4RegularStyle } from '../../designSystem/typos.mjs';
import { px2rem } from '../../helpers/rem.mjs';
import 'react/jsx-runtime';

var alertBadgeHeight = px2rem(18);
var useAlertThemeStyle = css(["", ""], function (props) {
  var _a, _b, _c;
  var palette = props.theme.getAlertElementPalette("alertBadge");
  return css(["background-color:", ";color:", ";"], (_b = (_a = props.backgroundColor) !== null && _a !== void 0 ? _a : palette.color) !== null && _b !== void 0 ? _b : props.theme.color.red, (_c = props.textColor) !== null && _c !== void 0 ? _c : palette.color ? palette.fog900 : props.theme.colorV2.colorSet.white900);
});
var AlertBadge = styled.div.withConfig({
  displayName: "AlertBadge",
  componentId: "sc-1b1ezjm-0"
})(["display:inline-flex;align-items:center;justify-content:center;min-width:", ";height:", ";border-radius:", ";padding:0 ", ";", ";"], px2rem(18), alertBadgeHeight, px2rem(10), px2rem(6), B4RegularStyle);
var CommonBadge = styled(AlertBadge).withConfig({
  displayName: "CommonBadge",
  componentId: "sc-1b1ezjm-1"
})(["", ";"], useAlertThemeStyle);
var CommonUnreadMark = styled.div.withConfig({
  displayName: "CommonUnreadMark",
  componentId: "sc-1b1ezjm-2"
})(["", ";width:", ";height:", ";border-radius:50%;"], useAlertThemeStyle, px2rem(6), px2rem(6));

export { AlertBadge, CommonBadge, CommonUnreadMark, useAlertThemeStyle };
